import { useAppSelector } from "../redux";

/**
 * Custom hook that returns the effective organization for the current user.
 * For admin users who have selected a different organization, returns the selected organization.
 * For regular users or admins who haven't selected a different organization, returns the user's default organization.
 *
 * Reads from session state directly (not the organization entities slice) so it is
 * never affected by paginated list fetches overwriting the entities map.
 */
export const useEffectiveOrganization = () => {
  const user = useAppSelector((state) => state.session.user);
  const selectedOrganizationId = useAppSelector((state) => state.session.selectedOrganizationId);
  const sessionOrganization = useAppSelector((state) => state.session.organization);
  const selectedOrganization = useAppSelector((state) => state.session.selectedOrganization);

  const isUsingSelectedOrg = user?.isAdmin && !!selectedOrganizationId && selectedOrganizationId !== user?.organizationId;

  const organization = isUsingSelectedOrg ? selectedOrganization : sessionOrganization;
  const organizationId = isUsingSelectedOrg ? selectedOrganizationId : user?.organizationId;

  return {
    /** The effective organization object */
    organization,
    /** The effective organization ID */
    organizationId,
    /** Whether the user is an admin using a selected organization (different from their default) */
    isUsingSelectedOrg,
  };
};
